// extracted by mini-css-extract-plugin
export default {"addForm":"AddPostModal_addForm__kYS4+","postOptions":"AddPostModal_postOptions__vzDmn","h1":"AddPostModal_h1__wojoR","inputFlex":"AddPostModal_inputFlex__RE2V3"};